// routers
import router from './workplan.route'
import teachingRouter from './teaching/teaching.route'
import academicRouter from './academicManagement/academic.route'
import consolidationRouter from './consolidationCP/consolidation.route'
import researchRouter from './research/research.route'
import extensionRouter from './extensionVisibility/extension.route'

import reviewRouter from './partials/review/review.route'
import reviewTeachingRouter from './partials/review/routes/teaching.route'
import reviewAcademicManagementRouter from './partials/review/routes/academicManagement.route'
import reviewConsolidationRouter from './partials/review/routes/consolidation.route'
import reviewInvestigationRouter from './partials/review/routes/investigation.route'
import reviewExtensionRouter from './partials/review/routes/extension.route'

// runs
import run from './workplan.run'
import indicatorsRun from './indicators/indicators.run'
import consolidationRun from './consolidationCP/consolidation.run'
import extensionRun from './extensionVisibility/extension.run'
import researchRun from './research/research.run'

// services
import WorkPlanSrv from './workplanSrv'
import WorkPlanModalSrv from './workplanModalSrv'
import WorkPlanIndicatorSrv from './workplanIndicatorSrv'

// controllers
import activitiesListCtrl from './teaching/activities/listActivities/activitiesListCtrl'
import subjectsListCtrl from './teaching/subjects/list/subjectsListCtrl'
import createActivityCtrl from './teaching/activities/createActivity/createActivityCtrl'
import consultCalendarCtrl from './teaching/studentAttention/consultCalendar/consultCalendarCtrl'
import scheduleListCtrl from './teaching/studentAttention/listSchedules/scheduleListCtrl'
import consultSummaryByAreaCtrl from './generalInformation/consultInformation/consultSummaryByAreaCtrl'
import planSubjectCtrl from './teaching/subjects/plan/planSubjectCtrl'
import endPlanningModalCtrl from './partials/modals/endPlanningModalCtrl'
import indicatorsCtrl from './indicators/indicatorsCtrl'
import indicatorsStartCtrl from './indicatorsStart/indicatorsStartCtrl'
import workPlanReviewPhaseCtrl from './start/reviewPhase/workplanReviewPhaseCtrl'
import workPlanReviewPhaseApprobationCtrl from './start/approbation/workplanReviewPhaseApprobationCtrl'
import workPlanReviewExecutionCtrl from './start/reviewExecution/workplanReviewExecutionCtrl'
import workPlanPhaseExecutionCtrl from './start/execution/workplanPhaseExecutionCtrl'
import workplanEvaluationCtrl from './start/evaluation/workplanEvaluationCtrl'

import chargesListCtrl from './academicManagement/charges/list/chargesListCtrl'
import createParticipationCtrl from './academicManagement/committeeParticipation/createParticipation/createParticipationCtrl'
import participationListCtrl from './academicManagement/committeeParticipation/list/participationsListCtrl'
import rolesListCtrl from './academicManagement/roles/list/rolesListCtrl'
import createRoleCtrl from './academicManagement/roles/createRole/createRoleCtrl'
import doctoralListCtrl from './consolidationCP/doctoralFormation/list/doctoralListCtrl'
import createDoctorateCtrl from './consolidationCP/doctoralFormation/create/createDoctorateCtrl'
import teachingDevListCtrl from './consolidationCP/teachingDevelopment/list/teachingDevListCtrl'
import createCourseCtrl from './consolidationCP/teachingDevelopment/createCourse/createCourseCtrl'
import learningCommunityListCtrl from './consolidationCP/learningAndPracticeCommunities/list/learningCommunityListCtrl'
import createLearningComunityCtrl from './consolidationCP/learningAndPracticeCommunities/create/createLearningComunityCtrl'
import reviewTeacherDevelopmentCtrl from './consolidationCP/teachingDevelopment/listTeacherJobsView/reviewTeacherDevelopmentCtrl'
import projectFormulationProposalsListCtrl from './extensionVisibility/projectFormulation/list/projectFormulationProposalsListCtrl'
import createProjectFormulationProposalCtrl from './extensionVisibility/projectFormulation/create/createProjectFormulationProposalCtrl'
import createExtensionProjectCtrl from './extensionVisibility/extensionProjects/create/createExtensionProjectCtrl'
import projectTypeCtrl from './extensionVisibility/projectFormulation/list/proposals/project-type-tag'
import extensionProjectsListCtrl from './extensionVisibility/extensionProjects/list/extensionProjectsListCtrl'
import projectStateCtrl from './extensionVisibility/extensionProjects/list/projects/project-state-tag'
import projectVisibilityCtrl from './extensionVisibility/visibility/list/projects/project-visibility-tag'

import OtherActivitiesListCtrl from './academicManagement/otherActivities/listActivities/otherActivitiesListCtrl'
import CreateOtherActivityCtrl from './academicManagement/otherActivities/createOtherActivity/createOtherActivityCtrl'
import itemRequiredModalCtrl from './partials/modals/itemRequiredModalCtrl'
import itemRequiredExecutionModalCtrl from './partials/modals/itemRequiredExecutionModalCtrl'

// Controladores de Investigacion
import projectsFormulationListCtrl from './research/projectsFormulation/list/projectsFormulationListCtrl'

// Controladores de Extension y Visibilidad
import createVisibilityCtrl from './extensionVisibility/visibility/create/createVisibilityCtrl'
import visibilityListCtrl from './extensionVisibility/visibility/list/visibilityListCtrl'
import createCounselingAndConsultancyCtrl from './extensionVisibility/counselingAndConsultancy/create/createCounselingAndConsultancyCtrl'
import counselingAndConsultancyListCtrl from './extensionVisibility/counselingAndConsultancy/list/counselingAndConsultancyListCtrl'
import createProjectFormulationCtrl from './research/projectsFormulation/createProjectFormulation/createProjectFormulationCtrl'
import projectsListCtrl from './research/projects/list/projectsListCtrl'
import createProjectCtrl from './research/projects/createProject/createProjectCtrl'
import productsListCtrl from './research/products/list/productsListCtrl'
import createProductCtrl from './research/products/createProduct/createProductCtrl'
import collaborationSpacesListCtrl from './research/collaborationSpaces/list/collaborationSpacesListCtrl'
import createSpaceCtrl from './research/collaborationSpaces/createSpace/createSpaceCtrl'
import CreateTrainingResearchCtrl from './research/trainingResearch/createTrainingResearch/createTrainingResearchCtrl'
import TrainingResearchListCtrl from './research/trainingResearch/list/trainingResearchListCtrl'
import CreateResultsTransferCtrl from './research/resultsTransfer/createResultsTransfer/createResultsTransferCtrl'
import ResultsTransferListCtrl from './research/resultsTransfer/list/resultsTransferListCtrl'
// Controladores de Extension y Visibilidad
import shortCoursesListCtrl from './extensionVisibility/shortCourses/list/shortCoursesListCtrl'
import createShortCoursesCtrl from './extensionVisibility/shortCourses/create/createShortCoursesCtrl'
import listTransversalProjectsCtrl from './extensionVisibility/modals/listTransversalProjectsCtrl'

// review controllers
import addActivityCtrl from './partials/review/modals/addActivityCtrl'
import registerExecutionCtrl from './partials/review/modals/registerExecutionCtrl'
import editChildrenExecutionCtrl from './partials/review/modals/editChildrenExecutionCtrl'
import executionEntriesCtrl from './partials/review/modals/executionEntriesCtrl'
import endStageModalCtrl from './partials/review/summary/modals/endStageModalCtrl'
import viewFileCtrl from './partials/review/modals/viewFileCtrl'
import feedbackReviewedModalCtrl from './partials/review/summary/modals/feedbackReviewedModalCtrl'

// custom chart controller
import customChartController from './partials/review/summary/evaluacionDeProfesoresTemplates/customChartController'

// reflexiones de portafolio evidencias model controller
import reflexionesDePortafolioEvidenciasController from './partials/review/summary/evaluacionDeProfesoresTemplates/dialogs/reflexionesDePortafolioEvidenciasController'

// global success modal
import successDialogCtrl from './modals/successDialogCtrl'

// review services
import ReviewSrv from './partials/review/reviewSrv'

import executionCtrl from './partials/review/executionCtrl'

// summary controllers
import summaryCtrl from './partials/review/summary/summaryCtrl'

// config file
import GlobalConfig from '../../../globals/globalConfig.json'
// standard modals
import ModalSrv from '../../../partials/modalSrv'

import warningApprovalCtrl from './partials/review/summary/modals/warningApprovalCtrl'

import autoevaluationController from './partials/review/summary/evaluacionDeProfesoresTemplates/controller/autoevaluationController'
import reflexionesportafolioController from './partials/review/summary/evaluacionDeProfesoresTemplates/controller/reflexionesportafolioController'

export default angular.module('app.workplan', [ WorkPlanSrv, WorkPlanModalSrv, WorkPlanIndicatorSrv, ModalSrv, ReviewSrv ])
	.config(router)
	.config(teachingRouter)
	.config(reviewRouter)
	.config(reviewTeachingRouter)
	.config(reviewAcademicManagementRouter)
	.config(reviewConsolidationRouter)
	.config(reviewInvestigationRouter)
	.config(reviewExtensionRouter)
	.config(academicRouter)
	.config(consolidationRouter)
	.config(researchRouter)
	.config(extensionRouter)
	.run(run)
	.run(indicatorsRun)
	.run(consolidationRun)
	.run(extensionRun)
	.run(researchRun)
	.controller('SubjectsListCtrl', subjectsListCtrl)
	.controller('ActivitiesListCtrl', activitiesListCtrl)
	.controller('CreateActivityCtrl', createActivityCtrl)
	.controller('ConsultCalendarCtrl', consultCalendarCtrl)
	.controller('ScheduleListCtrl', scheduleListCtrl)
	.controller('PlanSubjectCtrl', planSubjectCtrl)
	.controller('ConsultSummaryByAreaCtrl', consultSummaryByAreaCtrl)
	.controller('IndicatorsCtrl', indicatorsCtrl)
	.controller('ChargesListCtrl', chargesListCtrl)
	.controller('RolesListCtrl', rolesListCtrl)
	.controller('CreateRoleCtrl', createRoleCtrl)
	.controller('ParticipationListCtrl', participationListCtrl)
	.controller('CreateParticipationCtrl', createParticipationCtrl)
	.controller('DoctoralListCtrl', doctoralListCtrl)
	.controller('CreateDoctorateCtrl', createDoctorateCtrl)
	.controller('TeachingDevListCtrl', teachingDevListCtrl)
	.controller('CreateCourseCtrl', createCourseCtrl)
	.controller('LearningCommunityListCtrl', learningCommunityListCtrl)
	.controller('OtherActivitiesListCtrl', OtherActivitiesListCtrl)
	.controller('CreateLearningComunityCtrl', createLearningComunityCtrl)
	.controller('ReviewTeacherDevelopmentCtrl', reviewTeacherDevelopmentCtrl)
	.controller('CreateOtherActivityCtrl', CreateOtherActivityCtrl)
	.controller('projectTypeCtrl', projectTypeCtrl)
	.controller('ExtensionProjectsListCtrl', extensionProjectsListCtrl)
	.controller('projectVisibilityCtrl', projectVisibilityCtrl)
	.controller('IndicatorsStartCtrl', indicatorsStartCtrl)
	.controller('WorkPlanReviewPhaseCtrl', workPlanReviewPhaseCtrl)
	.controller('WorkPlanReviewPhaseApprobationCtrl', workPlanReviewPhaseApprobationCtrl)
	.controller('WorkPlanReviewExecutionCtrl', workPlanReviewExecutionCtrl)
	.controller('WorkPlanPhaseExecutionCtrl', workPlanPhaseExecutionCtrl)
	.controller('WorkplanEvaluationCtrl', workplanEvaluationCtrl)

// Transversal controllers
	.controller('ExecutionCtrl', executionCtrl)
	.controller('EndPlanningModalCtrl', endPlanningModalCtrl)
	.controller('EndStageModalCtrl', endStageModalCtrl)
	.controller('ViewFileCtrl', viewFileCtrl)
	.controller('FeedbackReviewedModalCtrl', feedbackReviewedModalCtrl)
	.controller('listTransversalProjectsCtrl', listTransversalProjectsCtrl)

// custom chart controller
	.controller('customChartController', customChartController)
	.controller('autoevaluationController', autoevaluationController)
	.controller('reflexionesportafolioController', reflexionesportafolioController)

// evidencias model controller
	.controller('reflexionesDePortafolioEvidenciasController', reflexionesDePortafolioEvidenciasController)  

// research Controllers
	.controller('ProjectsFormulationListCtrl', projectsFormulationListCtrl)
	.controller('CreateProjectFormulationCtrl', createProjectFormulationCtrl)
	.controller('ProjectsListCtrl', projectsListCtrl)
	.controller('CreateProjectCtrl', createProjectCtrl)
	.controller('ProductsListCtrl', productsListCtrl)
	.controller('CreateProductCtrl', createProductCtrl)
	.controller('CollaborationSpacesListCtrl', collaborationSpacesListCtrl)
	.controller('CreateSpaceCtrl', createSpaceCtrl)
	.controller('CreateTrainingResearchCtrl', CreateTrainingResearchCtrl)
	.controller('TrainingResearchListCtrl', TrainingResearchListCtrl)
	.controller('CreateResultsTransferCtrl', CreateResultsTransferCtrl)
	.controller('ResultsTransferListCtrl', ResultsTransferListCtrl)
// extension Controllers
	.controller('CreateVisibilityCtrl', createVisibilityCtrl)
	.controller('VisibilityListCtrl', visibilityListCtrl)
	.controller('CreateCounselingAndConsultancyCtrl', createCounselingAndConsultancyCtrl)
	.controller('CounselingAndConsultancyListCtrl', counselingAndConsultancyListCtrl)
	.controller('ProjectFormulationProposalsListCtrl', projectFormulationProposalsListCtrl)
	.controller('CreateProjectFormulationProposalCtrl', createProjectFormulationProposalCtrl)
	.controller('CreateExtensionProjectCtrl', createExtensionProjectCtrl)
	.controller('ShortCoursesListCtrl', shortCoursesListCtrl)
	.controller('CreateShortCoursesCtrl', createShortCoursesCtrl)
	.controller('ItemRequiredModalCtrl', itemRequiredModalCtrl)
	.controller('ItemRequiredExecutionModalCtrl', itemRequiredExecutionModalCtrl)
	.controller('SummaryCtrl', summaryCtrl)
	.controller('AddActivityCtrl', addActivityCtrl)
	.controller('RegisterExecutionCtrl', registerExecutionCtrl)
	.controller('EditChildrenExecutionCtrl', editChildrenExecutionCtrl)
	.controller('ExecutionEntriesCtrl', executionEntriesCtrl)
	.controller('warningApprovalCtrl', warningApprovalCtrl)
	.controller('SuccessDialogCtrl', successDialogCtrl)
	.constant('workplan', [ {
		title  : 'Plan de trabajo',
		icon   : 'mdi-image-tune',
		subMenu: [
			{
				title       : 'Inicio',
				url         : 'fullscreen.workPlanGeneralInformation',
				rolesAllowed: [ GlobalConfig.userRolesIds.teacher,
					GlobalConfig.userRolesIds.support,
					GlobalConfig.userRolesIds.generalConsultant,
					GlobalConfig.userRolesIds.unitAdmin ],
				menuRoleId          : [ GlobalConfig.modules.indexOption ],
				stageId             : [ GlobalConfig.workplanIdStages.planning ],
				showIfWorkplanActive: true,
			},
			{
				title       : 'Revisión',
				url         : 'fullscreen.workPlanReview',
				rolesAllowed: [ GlobalConfig.userRolesIds.reviewer,
					GlobalConfig.userRolesIds.support,
					GlobalConfig.userRolesIds.generalConsultant,
					GlobalConfig.userRolesIds.consultant ],
			},
			{
				title       : 'Aprobación',
				url         : 'fullscreen.workPlanApproval',
				rolesAllowed: [ GlobalConfig.userRolesIds.approver,
					GlobalConfig.userRolesIds.support,
					GlobalConfig.userRolesIds.generalConsultant,
					GlobalConfig.userRolesIds.consultant ],
			},
			{
				title       : 'Evaluación',
				url         : 'fullscreen.workPlanEvaluation',
				rolesAllowed: [ GlobalConfig.userRolesIds.approver,
					GlobalConfig.userRolesIds.support,
					GlobalConfig.userRolesIds.generalConsultant,
					GlobalConfig.userRolesIds.consultant ],
			},
			{
				title       : 'Revisión de la ejecución',
				url         : 'fullscreen.workPlanReviewExecution',
				rolesAllowed: [ GlobalConfig.userRolesIds.reviewer,
					GlobalConfig.userRolesIds.support,
					GlobalConfig.userRolesIds.generalConsultant,
					GlobalConfig.userRolesIds.consultant ],
			},
			{
				title               : 'Docencia',
				url                 : 'workplan.teachingSubjects',
				rolesAllowed        : [ GlobalConfig.userRolesIds.teacher, GlobalConfig.userRolesIds.support, GlobalConfig.userRolesIds.generalConsultant ],
				menuRoleId          : [ GlobalConfig.modules.teaching ],
				stageId             : [ GlobalConfig.workplanIdStages.planning ],
				showIfWorkplanActive: true,
			},
			{
				title               : 'Investigación e innovación',
				url                 : 'workplan.projectsFormulation',
				rolesAllowed        : [ GlobalConfig.userRolesIds.teacher, GlobalConfig.userRolesIds.support, GlobalConfig.userRolesIds.generalConsultant ],
				menuRoleId          : [ GlobalConfig.modules.investigation ],
				stageId             : [ GlobalConfig.workplanIdStages.planning ],
				showIfWorkplanActive: true,
			},
			{
				title               : 'Extensión y visibilidad',
				url                 : 'workplan.projectProposalFormulation',
				rolesAllowed        : [ GlobalConfig.userRolesIds.teacher, GlobalConfig.userRolesIds.support, GlobalConfig.userRolesIds.generalConsultant ],
				menuRoleId          : [ GlobalConfig.modules.extentionAndVisibility ],
				stageId             : [ GlobalConfig.workplanIdStages.planning ],
				showIfWorkplanActive: true,
			},
			{
				title               : 'Gestión Académica',
				url                 : 'workplan.delegationCharges',
				rolesAllowed        : [ GlobalConfig.userRolesIds.teacher, GlobalConfig.userRolesIds.support, GlobalConfig.userRolesIds.generalConsultant ],
				menuRoleId          : [ GlobalConfig.modules.academicManagement ],
				stageId             : [ GlobalConfig.workplanIdStages.planning ],
				showIfWorkplanActive: true,
			},
			{
				title               : 'Consolidación de cuerpo profesoral',
				url                 : 'workplan.teachingDevelopment',
				rolesAllowed        : [ GlobalConfig.userRolesIds.teacher, GlobalConfig.userRolesIds.support, GlobalConfig.userRolesIds.generalConsultant ],
				menuRoleId          : [ GlobalConfig.modules.consolidation ],
				stageId             : [ GlobalConfig.workplanIdStages.planning ],
				showIfWorkplanActive: true,
			},
			{
				title               : 'Ejecución',
				url                 : 'fullscreen.workPlanExecution',
				rolesAllowed        : [ GlobalConfig.userRolesIds.teacher, GlobalConfig.userRolesIds.support, GlobalConfig.userRolesIds.generalConsultant, GlobalConfig.userRolesIds.workplanConsultant ],
				menuRoleId          : [ GlobalConfig.modules.execution ],
				stageId             : [ GlobalConfig.workplanIdStages.execution ],
				showIfWorkplanActive: true,
	  },
	  {
				title               : 'Resumen',
				url                 : 'workplan.executionHistory',
				rolesAllowed        : [ GlobalConfig.userRolesIds.teacher, GlobalConfig.userRolesIds.support, GlobalConfig.userRolesIds.generalConsultant ],
				menuRoleId          : [ GlobalConfig.modules.execution ],
				stageId             : [ GlobalConfig.workplanIdStages.execution ],
				showIfWorkplanActive: true,
			},
			{
				title               : 'Resumen',
				url                 : 'workplan.history',
				rolesAllowed        : [ GlobalConfig.userRolesIds.teacher, GlobalConfig.userRolesIds.support, GlobalConfig.userRolesIds.generalConsultant ],
				menuRoleId          : [ GlobalConfig.modules.planning ],
				stageId             : [ GlobalConfig.workplanIdStages.planning ],
				showIfWorkplanActive: true,
			},
			{
				title       : 'Planes de Trabajo',
				url         : 'fullscreen.workplanList',
				rolesAllowed: [ GlobalConfig.userRolesIds.workPlanAdmin,
					GlobalConfig.userRolesIds.workplanConsultant,
					GlobalConfig.userRolesIds.unitAdmin,
					GlobalConfig.userRolesIds.gerencialConsultant,
					GlobalConfig.userRolesIds.workplanCommittee,
					GlobalConfig.userRolesIds.committee,
					GlobalConfig.userRolesIds.comiteeAdmin ],
			},

		],
	} ])
	.name



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/index.js